import React from "react";
import { useParams } from "react-router-dom"; // Import useParams
import MasterLayout from "../masterLayout/MasterLayout";
import ComplainFormPageCloseUpdate from "../components/ComplainFormPageCloseUpdate";

const ComplainFormCloseUpdate = () => {
    const { id } = useParams(); // Get the id from the URL parameters
  
  return (
    <div>
      <MasterLayout>
        <ComplainFormPageCloseUpdate  complainId={id} />
      </MasterLayout>
    </div>
  );
};

export default ComplainFormCloseUpdate;
